module.exports = __webpack_public_path__ + "static/media/settlementBtnEng.d7f7397f.png";